// eslint-disable-next-line require-await
export default async ms =>
  new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
